<template>
	<div class="container">
		<div>
			<a-row>
				<!-- 今日签到人数 -->
				<!-- <a-col class="itemCol" :span="6">
					<div class="col-item">
						<div class="text1">今日签到人数<icon-font type="icon-tuichu" /></div>
						<div class="text2">{{resultTimeData.signUserTotal}}</div>
					</div>
				</a-col> -->
				<!-- 当前待处理订单 -->
				<!-- <a-col class="itemCol" :span="6">
					<div class="col-item">
						<div class="text1">当前待处理订单</div>
						<div class="text2"> {{resultTimeData.signUserTotal}}</div>
					</div>

				</a-col> -->
			</a-row>
			<!--  -->


			<a-row>
				<!-- 会员总数 -->
				<a-col class="itemCol" :span="6">
					<div class="col-item" @click="toVipList('1')">
						<div class="text1">会员总数</div>
						<div class="text2">{{resultData.userTotal}}</div>
					</div>

				</a-col>
				<!-- 总推荐人数 -->
				<a-col class="itemCol" :span="6" @click="toVipList('2')">
					<div class="col-item">
						<div class="text1">总推荐人数</div>
						<div class="text2"> {{resultData.recommendUserNum}}</div>
					</div>

				</a-col>
				<!-- 当月注册人数 -->
				<a-col class="itemCol" :span="6" @click="toVipList('3')">
					<div class="col-item">
						<div class="text1">当月注册人数</div>
						<div class="text2">{{resultData.monthRegisterUserNum}}</div>
					</div>

				</a-col>
				<!-- 今日注册人数 -->
				<a-col class="itemCol" :span="6" @click="toVipList('4')">
					<div class="col-item">
						<div class="text1">今日注册人数</div>
						<div class="text2">{{resultData.nowRegisterUserNum}}</div>
					</div>

				</a-col>
			</a-row>
			<a-row>
				<!-- 总交易订单数 -->
				<a-col class="itemCol" :span="6" @click="toOrderList('1')">
					<div class="col-item">
						<div class="text1">总交易订单数</div>
						<div class="text2">{{resultData.orderNum}}</div>
					</div>

				</a-col>
				<!-- 总交易金额 -->
				<a-col class="itemCol" :span="6" @click="toOrderList('2')">
					<div class="col-item">
						<div class="text1">总交易金额</div>
						<div class="text2">{{resultData.orderPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 今日交易订单数 -->
				<a-col class="itemCol" :span="6" @click="toOrderList('3')">
					<div class="col-item">
						<div class="text1">今日交易订单数</div>
						<div class="text2">{{resultData.nowOrderNum}}</div>
					</div>

				</a-col>
				<!-- 今日交易金额 -->
				<a-col class="itemCol" :span="6" @click="toOrderList('4')">
					<div class="col-item">
						<div class="text1">今日交易金额</div>
						<div class="text2">{{resultData.nowOrderPrice|formatAmount}}</div>
					</div>

				</a-col>
			</a-row>
			<a-row>
				<!-- 总注册和绑定WS奖励 -->
				<a-col class="itemCol" :span="6">
					<div class="col-item">
						<div class="text1">
							<span class="t1" @click="toWalletList1('1')">注册奖励</span><span class="t1">和</span>
							<span class="t1" @click="toWalletList1('2')">绑定WS</span><span class="t1">和</span>
							<span class="t1" @click="toWalletList1('3')">安装APP</span>
						</div>
						<div class="text2">{{resultData.bindWsPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 总签到奖励 -->
				<a-col class="itemCol" :span="6" @click="toWalletList1('4')">
					<div class="col-item">
						<div class="text1">总签到奖励</div>
						<div class="text2">{{resultData.signPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 总交易数量奖励 -->
				<a-col class="itemCol" :span="6" @click="toWalletList1('5')">
					<div class="col-item">
						<div class="text1">总交易数量奖励</div>
						<div class="text2">{{resultData.awardOrderNumPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 总交易奖励 -->
				<a-col class="itemCol" :span="6" @click="toWalletList1('6')">
					<div class="col-item">
						<div class="text1">总交易奖励</div>
						<div class="text2">{{resultData.awardPrice|formatAmount}}</div>
					</div>
				</a-col>
			</a-row>
			<a-row>
				<!-- 总推荐奖励 -->
				<a-col class="itemCol" :span="6"  @click="toWalletList2('1')">
					<div class="col-item">
						<div class="text1">总推荐奖励</div>
						<div class="text2">{{resultData.recommendAwardPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 有效用户奖励 -->
				<a-col class="itemCol" :span="6"  @click="toWalletList2('2')">
					<div class="col-item">
						<div class="text1">有效用户奖励</div>
						<div class="text2">{{resultData.invalidInviteUserAwardPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 直接交易奖励 -->
				<a-col class="itemCol" :span="6"  @click="toWalletList2('3')">
					<div class="col-item">
						<div class="text1">直接交易奖励</div>
						<div class="text2">{{resultData.directInviteUserAwardPrice|formatAmount}}</div>
					</div>

				</a-col>
				<!-- 间接交易奖励 -->
				<a-col class="itemCol" :span="6"  @click="toWalletList2('4')">
					<div class="col-item">
						<div class="text1">间接交易奖励</div>
						<div class="text2">{{resultData.indirectInviteUserAwardPrice|formatAmount}}</div>
					</div>
				</a-col>
				<a-col class="itemCol" :span="6" @click="toDrawList('1')">
					<div class="col-item">
						<div class="text1">总提现金额</div>
						<div class="text2">{{resultData.withdrawPrice|formatAmount}}</div>
					</div>
				</a-col>
				<a-col class="itemCol" :span="6" @click="toDrawList('2')">
					<div class="col-item">
						<div class="text1">今日提现金额</div>
						<div class="text2">{{resultData.nowWithdrawPrice|formatAmount}}</div>
					</div>
				</a-col>
			</a-row>
		</div>
	</div>
</template>
<script>
	import {
		// getIndexDataApi,
		// getIndexTimeApi
	} from "../../api/index";
	export default {
		name: "WELCOME",
		data() {
			return {
				resultData: {},
				// resultTimeData: {}
			};
		},
		created() {
			this.getData();


			// setTimeout(() => {
			// 	this.getDataTime()
			// }, 2000)
		},
		activated() {},
		mounted() {

		},
		methods: {
			getData() {
				getIndexDataApi({})
					.then((res) => {
						if (res.resultStatus) {
							this.resultData = res.resultData
						} else {
							this.resultData = {}
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});
			},
			// 用户列表
			// 1跳转用户列表，deleteStatus= true
			// 2 点击跳转用户列表。带上参数  inviteUserStatus = true  deleteStatus = false
			// 3 跳转用户列表 带上时间参数  startDate  endDate  本月 格式 2025-11-11   deleteStatus = false
			// 4 跳转用户列表 带上时间参数 startDate  endDate 今日   deleteStatus = false
			toVipList(val){
				this.$store.commit("ADD_LABEL", "VIPLIST");
				if(val=='1'){
					this.$router.push({ name: 'VIPLIST', query: { deleteStatus: false,t: Date.now(),clear:true } })
				} else if(val=='2'){
					this.$router.push({ name: 'VIPLIST', query: { inviteUserStatus: true,deleteStatus: undefined,t: Date.now(),clear:true  } })
				} else if(val=='3'){
					this.$router.push({ name: 'VIPLIST', query: { deleteStatus: false,t: Date.now(),clear:true,isDate:true,isMonth:true  } })
				} else if(val=='4'){
					this.$router.push({ name: 'VIPLIST', query: { deleteStatus: false,t: Date.now(),clear:true,isDate:true,isToday:true } })
				} else {
				}
			},
			// 订单列表

			// 1 跳转订单列表 orderStatus=SUCCESS
			// 2 跳转订单列表 orderStatus=SUCCESS
			// 3 跳转订单列表 orderStatus=SUCCESS  startDate endDate 传今日
			// 4 跳转订单列表 orderStatus=SUCCESS startDate endDate 传今日
			toOrderList(val){
				this.$store.commit("ADD_LABEL", "ORDERLIST");
				if(val=='1'){
					this.$router.push({ name: 'ORDERLIST', query: { orderStatus: 'SUCCESS',t: Date.now(),clear:true  } })
				} else if(val=='2'){
					this.$router.push({ name: 'ORDERLIST', query: { orderStatus: 'SUCCESS',t: Date.now(),clear:true  } })
				} else if(val=='3'){
					this.$router.push({ name: 'ORDERLIST', query: { orderStatus: 'SUCCESS',t: Date.now(),clear:true ,isDate:true } })
				} else if(val=='4'){
					this.$router.push({ name: 'ORDERLIST', query: { orderStatus: 'SUCCESS',t: Date.now(),clear:true ,isDate:true } })
				} else {
				}
			},

			// 钱包明细
			// 1 钱包明细  financeRecordType=REGISTER
			// 2 钱包明细 financeRecordType=BIND_WS
			// 3 钱包明细 financeRecordType = INSTALL_APP
			// 4 钱包明细 financeRecordType =SIGN
			// 5 钱包明细 financeRecordType =TRADE_NUM
			// 6 用户列表  deleteStatus = false  awardPriceStatus=true
			toWalletList1(val){
				if(val=='1'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'REGISTER',t: Date.now(),clear:true } })
				} else if(val=='2'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'BIND_WS',t: Date.now(),clear:true } })
				} else if(val=='3'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'INSTALL_APP',t: Date.now(),clear:true } })
				} else if(val=='4'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'SIGN',t: Date.now(),clear:true } })
				} else if(val=='5'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'TRADE_NUM',t: Date.now(),clear:true } })
				} else if(val=='6'){
					this.$store.commit("ADD_LABEL", "VIPLIST");
					this.$router.push({ name: 'VIPLIST', query: { deleteStatus: false,awardPriceStatus:true,t: Date.now(),clear:true  } })
				} else {
				}
			},
			// 钱包明细
			// 1 钱包明细 financeRecordType=RECOMMENT
			// 2钱包明细 financeRecordType=RECOMMENT   remark=active user
			// 3钱包明细 financeRecordType=RECOMMENT   remark=Direct rewards
			// 3钱包明细 financeRecordType=RECOMMENT   remark=Indirect rewards
			toWalletList2(val){
				if(val=='1'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'RECOMMENT',t: Date.now(),clear:true} })
				} else if(val=='2'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'RECOMMENT',remark: 'active user',t: Date.now(),clear:true} })
				} else if(val=='3'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'RECOMMENT',remark: 'Direct rewards',t: Date.now(),clear:true} })
				} else if(val=='4'){
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({ name: 'WALLETLIST', query: { financeRecordType: 'RECOMMENT',remark: 'Indirect rewards',t: Date.now(),clear:true} })
				} else {
				}
			},

			// 提现列表
			// 1 提现列表 withdrawStatus=SUCCESS
			// 2 提现列表 withdrawStatus=SUCCESS  startDate endDate 今日日期
			toDrawList(val){
				if(val=='1'){
					// 总提现金额
					this.$store.commit("ADD_LABEL", "WITHDRAWALLIST");
					this.$router.push({ name: 'WITHDRAWALLIST', query: { withdrawStatus: 'SUCCESS',t: Date.now(),clear:true} })
				} else if(val=='2'){
					// 今日提现金额
					this.$store.commit("ADD_LABEL", "WITHDRAWALLIST");
					this.$router.push({ name: 'WITHDRAWALLIST', query: { withdrawStatus: 'SUCCESS',t: Date.now(),clear:true,isDate:true} })
				} else {
				}
			},


			getDataTime() {



				// getIndexTimeApi({})
				// 	.then((res) => {
				// 		if (res.resultStatus) {
				// 			this.resultTimeData = res.resultData
				// 		} else {
				// 			this.resultTimeData = {};
				// 		}
				// 	})
				// 	.catch((err) => {
				// 		console.error(err);
				// 	})
				// 	.finally(() => {
				// 		// this.loading = false;
				// 	});

			}


		},
	};
</script>
<style lang="less" scoped>
	.container {
		.itemCol {
			cursor: pointer;


			.col-item {
				background-color: #fff;
				border-radius: 20px;
				padding: 30px 20px;
				// margin-bottom: 10px;
				margin: 0 5px 10px;
				border: 1px solid #e7e4e4;

				.text1 {
					font-size: 14px;
					line-height: 14px;
					.t1{
						font-size: 14px;
						color: #333;
					}
				}

				.text2 {
					margin-top: 10px;
					font-size: 28px;
					line-height: 28px;

				}
			}


		}
	}
</style>
